import { render, staticRenderFns } from "./OrderReview.vue?vue&type=template&id=6c703af4&scoped=true&"
import script from "./OrderReview.vue?vue&type=script&lang=js&"
export * from "./OrderReview.vue?vue&type=script&lang=js&"
import style0 from "./OrderReview.vue?vue&type=style&index=0&id=6c703af4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c703af4",
  null
  
)

export default component.exports